

const ENBudgetLogs = {
	"Logs de orçamento": "Budget logs",
	"Selecione o orçamento acima para carregar os logs": "Select the budget above to load the logs"
};

export default ENBudgetLogs;
